/**
 * Улучшенные сообщения об ошибках для пользователей
 */

export const getFirebaseErrorMessage = (errorCode) => {
    const messages = {
        // Auth ошибки
        'auth/user-not-found': 'Пользователь с таким email не найден',
        'auth/wrong-password': 'Неверный пароль',
        'auth/email-already-in-use': 'Этот email уже используется',
        'auth/weak-password': 'Пароль слишком слабый (минимум 6 символов)',
        'auth/invalid-email': 'Некорректный email адрес',
        'auth/too-many-requests': 'Слишком много попыток. Попробуйте позже',
        'auth/user-disabled': 'Этот аккаунт заблокирован',
        'auth/operation-not-allowed': 'Операция не разрешена',
        'auth/invalid-credential': 'Неверные учетные данные',

        // Firestore ошибки
        'permission-denied': 'Недостаточно прав доступа',
        'unavailable': 'Сервис временно недоступен. Попробуйте позже',
        'not-found': 'Данные не найдены',
        'already-exists': 'Данные уже существуют',
        'resource-exhausted': 'Превышен лимит запросов',
        'failed-precondition': 'Операция невозможна в текущем состоянии',
        'aborted': 'Операция прервана',
        'out-of-range': 'Значение вне допустимого диапазона',
        'unimplemented': 'Функция не реализована',
        'internal': 'Внутренняя ошибка сервера',
        'data-loss': 'Потеря данных',

        // Network ошибки
        'network-request-failed': 'Ошибка сети. Проверьте подключение к интернету',
        'timeout': 'Время ожидания истекло. Попробуйте еще раз'
    };

    return messages[errorCode] || 'Произошла ошибка. Попробуйте еще раз';
};

export const getPaymentErrorMessage = (errorCode) => {
    const messages = {
        'insufficient-funds': 'Недостаточно средств на карте',
        'card-declined': 'Карта отклонена банком',
        'invalid-card': 'Некорректные данные карты',
        'expired-card': 'Срок действия карты истек',
        'invalid-cvv': 'Неверный CVV код',
        'transaction-declined': 'Транзакция отклонена',
        'invalid-amount': 'Некорректная сумма платежа',
        'duplicate-transaction': 'Дублирующаяся транзакция'
    };

    return messages[errorCode] || 'Ошибка при проведении платежа';
};

/**
 * Форматирование ошибки для логирования
 */
export const formatErrorForLog = (error, context = {}) => {
    return {
        message: error.message || 'Unknown error',
        code: error.code,
        stack: error.stack,
        context,
        timestamp: new Date().toISOString()
    };
};

export default {
    getFirebaseErrorMessage,
    getPaymentErrorMessage,
    formatErrorForLog
};
